import React from "react";
import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import DriveFileMoveOutlinedIcon from "@mui/icons-material/DriveFileMoveOutlined";
import { locale } from "../../utils/LocaleManager";
import { useRolePermissionsStore } from "../../stores/rolePermissionsStore";

const FolderMenu = ({
  anchorEl,
  open,
  setOpen,
  contextMenu,
  handleRename,
  handleDelete,
  handleMove,
}: any) => {
  const rolePermissions = useRolePermissionsStore(
    (state: any) => state.rolePermissions,
  );

  const handleClose = () => {
    setOpen(false);
  };

  const handleMenuItemClick = (action: () => void) => {
    setOpen(false);
    action();
  };

  if (!rolePermissions?.folder?.rename && !rolePermissions?.folder?.move && !rolePermissions?.folder?.delete) {
    return null;
  }

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      anchorReference={contextMenu ? "anchorPosition" : "anchorEl"}
      anchorPosition={
        contextMenu !== null
          ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
          : undefined
      }
    >
      {rolePermissions?.folder?.rename && (
        <MenuItem
          key="rename"
          onClick={() => handleMenuItemClick(handleRename)}
        >
          <ListItemIcon>
            <DriveFileRenameOutlineIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>{locale.control_rename}</ListItemText>
        </MenuItem>
      )}
      {rolePermissions?.folder?.move && (
        <MenuItem
          key="move"
          onClick={() => handleMenuItemClick(handleMove)}
        >
          <ListItemIcon>
            <DriveFileMoveOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>{locale.control_move}</ListItemText>
        </MenuItem>
      )}
      {rolePermissions?.folder?.delete && (
        <MenuItem
          key="delete"
          onClick={() => handleMenuItemClick(handleDelete)}
        >
          <ListItemIcon>
            <DeleteOutlineOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>{locale.control_delete}</ListItemText>
        </MenuItem>
      )}
    </Menu>
  );
};

export default FolderMenu;
